import { IMembro } from '@/@types/EstruturaOrganizacional';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { Loading } from '@/components/shared/Loading';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';

const ComposicaoCIIR = () => {
    const [composicaoCIIR, setComposicaoCIIR] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCIIR = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/CIIR';

            await api.get(url)
                .then(response => {
                    setComposicaoCIIR(response.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCIIR();

    }, []);

    return(
        <>
            <h1>Composição CIIR</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCIIR.map(representante  => {
                            return (
                                <MembroItem 
                                    key={representante._id}
                                    data={{
                                    representanteFuncao: representante.funcao.funcaoweb,
                                    representanteTitulo: representante.representante.funcao_representante,
                                    representanteNome: representante.representante.nome,
                                    representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                    foto: representante.representante.foto
                                }} />
                            );
                    })}
                </ContainerMembros>
            )}
        </>
    );
}

export { ComposicaoCIIR };